<template>
  <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document" style="max-width: 60% !important;">
      <div class="modal-content">
        <div class="modal-header">
            
          <h5 class="modal-title">Create Product </h5>

          
          <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
            aria-label="btn-close"></button>
        </div>

        <div class="modal-body">
          <form ref="formElement">
            <div class="row">

 

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="product_id" class="col-form-label" style="padding-left: 25px"> Product Id <span style="color: red;">*</span></label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.product_id" @input="removeSpaces" maxlength="50" required />

                        <div v-if="errors.product_id">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.product_id[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="product_name" class="col-form-label" style="padding-left: 25px"> Product Name <span style="color: red;">*</span> </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.product_name" maxlength="250" required />

                        <div v-if="errors.product_name">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.product_name[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="product_alias" class="col-form-label" style="padding-left: 25px"> Product Alias <span style="color: red;">*</span> </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.product_alias" maxlength="250" required />

                        <div v-if="errors.product_alias">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.product_alias[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="category_in" class="col-form-label" style="padding-left: 25px"> Category IN <span style="color: red;">*</span> </label>
                      </div>
                      <div class="col-lg-8">
                        

                         <v-select
                          :options="fetchCategoryIn"
                          v-model="forms.category_in"
                          label="code"
                          return-object
                        ></v-select>


                        <div v-if="errors.category_in">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.category_in[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
    

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="category_dn" class="col-form-label" style="padding-left: 25px"> Category DN <span style="color: red;">*</span> </label>
                      </div>
                      <div class="col-lg-8">
                        

                         <v-select
                          :options="fetchCategoryDn"
                          v-model="forms.category_dn"
                          label="code"
                          return-object
                        ></v-select>

                        <div v-if="errors.category_dn">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.category_dn[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

  
   

 


          
            </div>
          </form>
 



        </div>

        <div class="modal-footer">

          <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')"> Close </button>

          <button class="btn btn-success" type="submit" v-on:click="saveAssign">Save</button>
          
        </div>

      </div>
    </div>
 

  </div>


</template>

<script> 
export default {
  components: {
    
  },
  name: "ModalPointLoad",
  emits: ["closeModal"],
  props: {
    showModal: Boolean,
    data: null,
  },
  watch: {
    showModal: {
      handler(newVal) {
            
        const formElement = this.$refs.formElement;
        if (formElement) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                const inputs = formElement.querySelectorAll('.multiselect__input');
                inputs.forEach(input => {
                  input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                });
              }
            });
          });

          const inputs = formElement.querySelectorAll('.multiselect__input');
          inputs.forEach(input => {
            observer.observe(input, { attributes: true });
          });
        }

        this.forms = this.data
      
        this.active = newVal;
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
        forms: {master_fr_id:"", product_id:"", product_name:"",product_alias:"",category_in:"",category_dn:"", create_by:"", update_by:"" , created_at:"", updated_at:""},
        errors: [],
        fetchCategoryIn:["-","HANDLING","DOCUMENTS","TRANSPORT","OTHERS","STORAGE","DEMMURAGE DETENTION"],
        fetchCategoryDn:["-","OTHERS","STORAGE","DEMMURAGE DETENTION"],
    };
  },
  methods: {
    removeSpaces() {
      // Regex \s mencari semua jenis spasi (tab, space, enter)
      this.forms.product_id = this.forms.product_id.replace(/\s/g, '');
    },

    saveAssign() {
        this.isLoading = true; 

        if (this.forms.product_id.length === 0) {
            this.isLoading = false;
            return this.error("product id wajib di isi");
        }

        if (this.forms.product_name.length === 0) {
            this.isLoading = false;
            return this.error("product name wajib di pilih");
        }

        if (this.forms.product_alias.length === 0) {
            this.isLoading = false;
            return this.error("product alias wajib di pilih");
        }

        if (this.forms.category_in.length === 0) {
            this.isLoading = false;
            return this.error("category_in wajib di pilih");
        }

        if (this.forms.category_dn.length === 0) {
            this.isLoading = false;
            return this.error("category_dn wajib di pilih");
        }

        var dataSend = {};
        
        dataSend = { 
            "product_id": this.forms.product_id,
            "product_name": this.forms.product_name,
            "product_alias": this.forms.product_alias,
            "category_in": this.forms.category_in,
            "category_dn": this.forms.category_dn
        };

        const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/exim/master-freight/create";

        return this.$http
        .post(
            baseURI,
            dataSend,
            { timeout: 10000 }
        )
        .then((response) => {

            this.isLoading = false;
            this.errors = [];

            if (response.status == 200) {
                this.success2('Success Save data !!');
                this.$emit("closeModal");
            }
 


        })
        .catch(error => {
            this.isLoading = false;

            if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
            return;
            }

            if (error.response) {
    
            if (error.response.status === 422) {
                
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);

            } else if (error.response.status === 500) {
                this.$router.push("/server-error");
            } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
            } else {
                this.$router.push("/page-not-found");
            }
            }
        });



    },
 
    toFixed(val){
      let data = parseFloat(val).toFixed(2).replace('.', ',');

      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")

    },
 
     
    success2(msg) {
      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },


    errorAlert(msg) {
      this.$swal({
        icon: 'danger',
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },


     
    alert(msg) {

      let pesan = '';

      if(msg.length > 0){

        msg.forEach((psn) => {
            pesan = pesan + '<br> id : ' + psn.order_no + ' , status : ' + psn.status
        });

      }

      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: "<p>* " + pesan + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },
  
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    error(kata) {
      this.$swal.fire({
        icon: "error",
        title: "Perhatian!",
        text: kata,
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6", // bisa diganti warna sesuai selera
        position: "center",
      });
    },
  
   
 



  },
  mounted() {

    
 
  },
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
/* Important part */
.modal-dialog{
    overflow-y: initial !important
}
.modal-body{
    height: 30vh;
    overflow-y: auto;
}
</style>